/**
 * Formats a number with dots for thousands separators and commas for decimal places
 * Example: 1234567.89 -> 1.234.567,89
 */
export const formatNumber = (value: number | string): string => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(numValue)) {
    return '0,00';
  }

  // Convert to string with 2 decimal places
  const formatted = numValue.toFixed(2);
  
  // Split by decimal point
  const [integerPart, decimalPart] = formatted.split('.');
  
  // Add dots for thousands separators
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  
  // Return with comma as decimal separator
  return `${formattedInteger},${decimalPart}`;
};

/**
 * Formats a number for display in tables and forms
 * Handles null/undefined values gracefully
 */
export const formatDisplayNumber = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '0,00';
  }
  
  return formatNumber(value);
};
